export const COLORTEXTO = '#fff'
export const COLORTEXTOSUAVE = '#5a6a85'